<app-tab-toolbar [tabId]="'salary1'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCurrencyCarriedForward"
  [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement"
  [showKeywordsToggle]="true" [keywordsVisible]="showKeywords"
  (keywordsVisibleChange)="showKeywords = $event"
  (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)"
  (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="salary-content" [formGroup]="form" [appReadOnlyTab]="'salary1'">

  @if (isCurrencyCarriedForward) {
    <div class="year-warning">
      <mat-icon>info</mat-icon>
      <span>Currency carried forward from a previous year. Compensation data must be entered for this year.</span>
    </div>
  }

  <!-- Board of Directors -->
  <div class="board-section">
    <h3 class="section-title">{{ companyBoardType === 0 ? 'Board of Directors' : 'Supervisory Board' }}</h3>

    @if (boardDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="boardDataSource" class="salary-table" formArrayName="boardRows" matSort #boardSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onBoardSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <ng-container matColumnDef="currency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <select formControlName="currencyId" class="ht-input">
              <option [ngValue]="null"></option>
              @for (c of currencies; track c.id) {
                <option [ngValue]="c.id">{{ c.name }}</option>
              }
            </select>
            @if (otherMeasurement && isDifferent(row.currencyId, getOtherBoardMember(row.directorId)?.currencyId)) {<span class="ht-other ht-other-left">{{ getOtherBoardMember(row.directorId)?.currencyName }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="classification">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Classification</th>
          <td mat-cell *matCellDef="let row">{{ getClassificationName(row.classification) }}</td>
        </ng-container>

        <ng-container matColumnDef="occupation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Occupation</th>
          <td mat-cell *matCellDef="let row">{{ getOccupationName(row.occupationId) }}</td>
        </ng-container>

        <ng-container matColumnDef="salaryOrFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Salary or Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="salaryOrFees" class="ht-input" [title]="row.salaryOrFees > 0 ? formatOther(row.salaryOrFees) : ''">
            @if (otherMeasurement && isDifferent(row.salaryOrFees, getOtherBoardMember(row.directorId)?.salaryOrFees)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.salaryOrFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="committeeMeetingFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Committee Meeting Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="committeeMeetingFees" class="ht-input" [title]="row.committeeMeetingFees > 0 ? formatOther(row.committeeMeetingFees) : ''">
            @if (otherMeasurement && isDifferent(row.committeeMeetingFees, getOtherBoardMember(row.directorId)?.committeeMeetingFees)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.committeeMeetingFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="bonus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bonus-Annual Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="bonus" class="ht-input" [title]="row.bonus > 0 ? formatOther(row.bonus) : ''">
            @if (otherMeasurement && isDifferent(row.bonus, getOtherBoardMember(row.directorId)?.bonus)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.bonus) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="taxableBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Taxable benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="taxableBenefits" class="ht-input" [title]="row.taxableBenefits > 0 ? formatOther(row.taxableBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.taxableBenefits, getOtherBoardMember(row.directorId)?.taxableBenefits)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.taxableBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="stockAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="stockAwards" class="ht-input" [title]="row.stockAwards > 0 ? formatOther(row.stockAwards) : ''">
            @if (otherMeasurement && isDifferent(row.stockAwards, getOtherBoardMember(row.directorId)?.stockAwards)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.stockAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="optionAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Option Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="optionAwards" class="ht-input" [title]="row.optionAwards > 0 ? formatOther(row.optionAwards) : ''">
            @if (otherMeasurement && isDifferent(row.optionAwards, getOtherBoardMember(row.directorId)?.optionAwards)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.optionAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="nonEquity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Equity Incentive Plan Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="nonEquity" class="ht-input" [title]="row.nonEquity > 0 ? formatOther(row.nonEquity) : ''">
            @if (otherMeasurement && isDifferent(row.nonEquity, getOtherBoardMember(row.directorId)?.nonEquity)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.nonEquity) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longTerm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long Term Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longTerm" class="ht-input" [title]="row.longTerm > 0 ? formatOther(row.longTerm) : ''">
            @if (otherMeasurement && isDifferent(row.longTerm, getOtherBoardMember(row.directorId)?.longTerm)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.longTerm) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Pension value</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionValue" class="ht-input" [title]="row.pensionValue > 0 ? formatOther(row.pensionValue) : ''">
            @if (otherMeasurement && isDifferent(row.pensionValue, getOtherBoardMember(row.directorId)?.pensionValue)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.pensionValue) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionChange">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Change in Pension Value and Nonqualified Deferred Compensation Earnings</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionChange" class="ht-input" [title]="row.pensionChange > 0 ? formatOther(row.pensionChange) : ''">
            @if (otherMeasurement && isDifferent(row.pensionChange, getOtherBoardMember(row.directorId)?.pensionChange)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.pensionChange) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="superannuationPensionBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Superannuation &amp; pension benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="superannuationPensionBenefits" class="ht-input" [title]="row.superannuationPensionBenefits > 0 ? formatOther(row.superannuationPensionBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.superannuationPensionBenefits, getOtherBoardMember(row.directorId)?.superannuationPensionBenefits)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.superannuationPensionBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="retirementBenefit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Retirement (Post Employment) Benefit</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="retirementBenefit" class="ht-input" [title]="row.retirementBenefit > 0 ? formatOther(row.retirementBenefit) : ''">
            @if (otherMeasurement && isDifferent(row.retirementBenefit, getOtherBoardMember(row.directorId)?.retirementBenefit)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.retirementBenefit) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="terminationBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Termination benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="terminationBenefits" class="ht-input" [title]="row.terminationBenefits > 0 ? formatOther(row.terminationBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.terminationBenefits, getOtherBoardMember(row.directorId)?.terminationBenefits)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.terminationBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longServiceLeave">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long service leave</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longServiceLeave" class="ht-input" [title]="row.longServiceLeave > 0 ? formatOther(row.longServiceLeave) : ''">
            @if (otherMeasurement && isDifferent(row.longServiceLeave, getOtherBoardMember(row.directorId)?.longServiceLeave)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.longServiceLeave) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="allOther">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>All Other</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="allOther" class="ht-input" [title]="row.allOther > 0 ? formatOther(row.allOther) : ''">
            @if (otherMeasurement && isDifferent(row.allOther, getOtherBoardMember(row.directorId)?.allOther)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.allOther) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalCompensation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">Total Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="total-cell">
            <input type="text" class="ht-input ht-input-calculated" readonly [value]="formatOther(getBoardTotal(i))" [title]="getBoardTotal(i) > 0 ? formatOther(getBoardTotal(i)) : ''">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>

  <!-- Management Board -->
  @if (companyBoardType !== 0) {
  <div class="board-section">
    <h3 class="section-title">Management Board</h3>

    @if (managementDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="managementDataSource" class="salary-table" formArrayName="managementRows" matSort #managementSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onManagementSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <ng-container matColumnDef="currency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <select formControlName="currencyId" class="ht-input">
              <option [ngValue]="null"></option>
              @for (c of currencies; track c.id) {
                <option [ngValue]="c.id">{{ c.name }}</option>
              }
            </select>
            @if (otherMeasurement && isDifferent(row.currencyId, getOtherManagementMember(row.directorId)?.currencyId)) {<span class="ht-other ht-other-left">{{ getOtherManagementMember(row.directorId)?.currencyName }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="classification">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Classification</th>
          <td mat-cell *matCellDef="let row">{{ getClassificationName(row.classification) }}</td>
        </ng-container>

        <ng-container matColumnDef="occupation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Occupation</th>
          <td mat-cell *matCellDef="let row">{{ getOccupationName(row.occupationId) }}</td>
        </ng-container>

        <ng-container matColumnDef="salaryOrFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Salary or Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="salaryOrFees" class="ht-input" [title]="row.salaryOrFees > 0 ? formatOther(row.salaryOrFees) : ''">
            @if (otherMeasurement && isDifferent(row.salaryOrFees, getOtherManagementMember(row.directorId)?.salaryOrFees)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.salaryOrFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="committeeMeetingFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Committee Meeting Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="committeeMeetingFees" class="ht-input" [title]="row.committeeMeetingFees > 0 ? formatOther(row.committeeMeetingFees) : ''">
            @if (otherMeasurement && isDifferent(row.committeeMeetingFees, getOtherManagementMember(row.directorId)?.committeeMeetingFees)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.committeeMeetingFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="bonus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bonus-Annual Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="bonus" class="ht-input" [title]="row.bonus > 0 ? formatOther(row.bonus) : ''">
            @if (otherMeasurement && isDifferent(row.bonus, getOtherManagementMember(row.directorId)?.bonus)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.bonus) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="taxableBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Taxable benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="taxableBenefits" class="ht-input" [title]="row.taxableBenefits > 0 ? formatOther(row.taxableBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.taxableBenefits, getOtherManagementMember(row.directorId)?.taxableBenefits)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.taxableBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="stockAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="stockAwards" class="ht-input" [title]="row.stockAwards > 0 ? formatOther(row.stockAwards) : ''">
            @if (otherMeasurement && isDifferent(row.stockAwards, getOtherManagementMember(row.directorId)?.stockAwards)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.stockAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="optionAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Option Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="optionAwards" class="ht-input" [title]="row.optionAwards > 0 ? formatOther(row.optionAwards) : ''">
            @if (otherMeasurement && isDifferent(row.optionAwards, getOtherManagementMember(row.directorId)?.optionAwards)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.optionAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="nonEquity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Equity Incentive Plan Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="nonEquity" class="ht-input" [title]="row.nonEquity > 0 ? formatOther(row.nonEquity) : ''">
            @if (otherMeasurement && isDifferent(row.nonEquity, getOtherManagementMember(row.directorId)?.nonEquity)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.nonEquity) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longTerm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long Term Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longTerm" class="ht-input" [title]="row.longTerm > 0 ? formatOther(row.longTerm) : ''">
            @if (otherMeasurement && isDifferent(row.longTerm, getOtherManagementMember(row.directorId)?.longTerm)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.longTerm) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Pension value</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionValue" class="ht-input" [title]="row.pensionValue > 0 ? formatOther(row.pensionValue) : ''">
            @if (otherMeasurement && isDifferent(row.pensionValue, getOtherManagementMember(row.directorId)?.pensionValue)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.pensionValue) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionChange">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Change in Pension Value and Nonqualified Deferred Compensation Earnings</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionChange" class="ht-input" [title]="row.pensionChange > 0 ? formatOther(row.pensionChange) : ''">
            @if (otherMeasurement && isDifferent(row.pensionChange, getOtherManagementMember(row.directorId)?.pensionChange)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.pensionChange) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="superannuationPensionBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Superannuation &amp; pension benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="superannuationPensionBenefits" class="ht-input" [title]="row.superannuationPensionBenefits > 0 ? formatOther(row.superannuationPensionBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.superannuationPensionBenefits, getOtherManagementMember(row.directorId)?.superannuationPensionBenefits)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.superannuationPensionBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="retirementBenefit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Retirement (Post Employment) Benefit</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="retirementBenefit" class="ht-input" [title]="row.retirementBenefit > 0 ? formatOther(row.retirementBenefit) : ''">
            @if (otherMeasurement && isDifferent(row.retirementBenefit, getOtherManagementMember(row.directorId)?.retirementBenefit)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.retirementBenefit) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="terminationBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Termination benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="terminationBenefits" class="ht-input" [title]="row.terminationBenefits > 0 ? formatOther(row.terminationBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.terminationBenefits, getOtherManagementMember(row.directorId)?.terminationBenefits)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.terminationBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longServiceLeave">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long service leave</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longServiceLeave" class="ht-input" [title]="row.longServiceLeave > 0 ? formatOther(row.longServiceLeave) : ''">
            @if (otherMeasurement && isDifferent(row.longServiceLeave, getOtherManagementMember(row.directorId)?.longServiceLeave)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.longServiceLeave) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="allOther">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>All Other</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="allOther" class="ht-input" [title]="row.allOther > 0 ? formatOther(row.allOther) : ''">
            @if (otherMeasurement && isDifferent(row.allOther, getOtherManagementMember(row.directorId)?.allOther)) {<span class="ht-other">{{ formatOther(getOtherManagementMember(row.directorId)?.allOther) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalCompensation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">Total Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="total-cell">
            <input type="text" class="ht-input ht-input-calculated" readonly [value]="formatOther(getManagementTotal(i))" [title]="getManagementTotal(i) > 0 ? formatOther(getManagementTotal(i)) : ''">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>
  }

  <!-- Keywords Section -->
  @if (showKeywords) {
    <div class="board-section keywords-section" formGroupName="keywords">
      <div class="keywords-header">
        <span>Keywords</span>
      </div>
      <div class="keywords-fields">
        <div class="keywords-column">
          <app-keyword-input name="executiveCompensationOne" label="Executive Compensation 1" />
        </div>
        <div class="keywords-column">
          <app-keyword-input name="executiveCompensationTwo" label="Executive Compensation 2" />
        </div>
        <div class="keywords-column">
          <app-keyword-input name="directorsCompensationOne" label="Directors Compensation 1" />
        </div>
        <div class="keywords-column">
          <app-keyword-input name="directorsCompensationTwo" label="Directors Compensation 2" />
        </div>
      </div>
    </div>
  }

  <!-- Executive Management -->
  <div class="board-section">
    <h3 class="section-title">Executive Management</h3>

    @if (executiveDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="executiveDataSource" class="salary-table executive-table" formArrayName="executiveRows" matSort #executiveSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onExecutiveSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <ng-container matColumnDef="currency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <select formControlName="currencyId" class="ht-input">
              <option [ngValue]="null"></option>
              @for (c of currencies; track c.id) {
                <option [ngValue]="c.id">{{ c.name }}</option>
              }
            </select>
            @if (otherMeasurement && isDifferent(row.currencyId, getOtherExecutiveMember(row.directorId)?.currencyId)) {<span class="ht-other ht-other-left">{{ getOtherExecutiveMember(row.directorId)?.currencyName }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="occupation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Occupation</th>
          <td mat-cell *matCellDef="let row">{{ getOccupationName(row.occupationId) }}</td>
        </ng-container>

        <ng-container matColumnDef="salaryOrFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Salary or Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="salaryOrFees" class="ht-input" [title]="row.salaryOrFees > 0 ? formatOther(row.salaryOrFees) : ''">
            @if (otherMeasurement && isDifferent(row.salaryOrFees, getOtherExecutiveMember(row.directorId)?.salaryOrFees)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.salaryOrFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="committeeMeetingFees">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Committee Meeting Fees</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="committeeMeetingFees" class="ht-input" [title]="row.committeeMeetingFees > 0 ? formatOther(row.committeeMeetingFees) : ''">
            @if (otherMeasurement && isDifferent(row.committeeMeetingFees, getOtherExecutiveMember(row.directorId)?.committeeMeetingFees)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.committeeMeetingFees) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="bonus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bonus-Annual Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="bonus" class="ht-input" [title]="row.bonus > 0 ? formatOther(row.bonus) : ''">
            @if (otherMeasurement && isDifferent(row.bonus, getOtherExecutiveMember(row.directorId)?.bonus)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.bonus) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="taxableBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Taxable benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="taxableBenefits" class="ht-input" [title]="row.taxableBenefits > 0 ? formatOther(row.taxableBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.taxableBenefits, getOtherExecutiveMember(row.directorId)?.taxableBenefits)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.taxableBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="stockAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="stockAwards" class="ht-input" [title]="row.stockAwards > 0 ? formatOther(row.stockAwards) : ''">
            @if (otherMeasurement && isDifferent(row.stockAwards, getOtherExecutiveMember(row.directorId)?.stockAwards)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.stockAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="optionAwards">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Option Awards</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="optionAwards" class="ht-input" [title]="row.optionAwards > 0 ? formatOther(row.optionAwards) : ''">
            @if (otherMeasurement && isDifferent(row.optionAwards, getOtherExecutiveMember(row.directorId)?.optionAwards)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.optionAwards) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="nonEquity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Equity Incentive Plan Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="nonEquity" class="ht-input" [title]="row.nonEquity > 0 ? formatOther(row.nonEquity) : ''">
            @if (otherMeasurement && isDifferent(row.nonEquity, getOtherExecutiveMember(row.directorId)?.nonEquity)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.nonEquity) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longTerm">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long Term Incentive Plan</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longTerm" class="ht-input" [title]="row.longTerm > 0 ? formatOther(row.longTerm) : ''">
            @if (otherMeasurement && isDifferent(row.longTerm, getOtherExecutiveMember(row.directorId)?.longTerm)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.longTerm) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionValue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Pension value</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionValue" class="ht-input" [title]="row.pensionValue > 0 ? formatOther(row.pensionValue) : ''">
            @if (otherMeasurement && isDifferent(row.pensionValue, getOtherExecutiveMember(row.directorId)?.pensionValue)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.pensionValue) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="pensionChange">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Change in Pension Value and Nonqualified Deferred Compensation Earnings</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="pensionChange" class="ht-input" [title]="row.pensionChange > 0 ? formatOther(row.pensionChange) : ''">
            @if (otherMeasurement && isDifferent(row.pensionChange, getOtherExecutiveMember(row.directorId)?.pensionChange)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.pensionChange) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="superannuationPensionBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Superannuation &amp; pension benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="superannuationPensionBenefits" class="ht-input" [title]="row.superannuationPensionBenefits > 0 ? formatOther(row.superannuationPensionBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.superannuationPensionBenefits, getOtherExecutiveMember(row.directorId)?.superannuationPensionBenefits)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.superannuationPensionBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="retirementBenefit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Retirement (Post Employment) Benefit</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="retirementBenefit" class="ht-input" [title]="row.retirementBenefit > 0 ? formatOther(row.retirementBenefit) : ''">
            @if (otherMeasurement && isDifferent(row.retirementBenefit, getOtherExecutiveMember(row.directorId)?.retirementBenefit)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.retirementBenefit) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="terminationBenefits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Termination benefits</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="terminationBenefits" class="ht-input" [title]="row.terminationBenefits > 0 ? formatOther(row.terminationBenefits) : ''">
            @if (otherMeasurement && isDifferent(row.terminationBenefits, getOtherExecutiveMember(row.directorId)?.terminationBenefits)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.terminationBenefits) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="longServiceLeave">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Long service leave</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="longServiceLeave" class="ht-input" [title]="row.longServiceLeave > 0 ? formatOther(row.longServiceLeave) : ''">
            @if (otherMeasurement && isDifferent(row.longServiceLeave, getOtherExecutiveMember(row.directorId)?.longServiceLeave)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.longServiceLeave) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="allOther">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>All Other</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="allOther" class="ht-input" [title]="row.allOther > 0 ? formatOther(row.allOther) : ''">
            @if (otherMeasurement && isDifferent(row.allOther, getOtherExecutiveMember(row.directorId)?.allOther)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.allOther) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalCompensation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">Total Compensation</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i" class="total-cell">
            <input type="text" class="ht-input ht-input-calculated" readonly [value]="formatOther(getExecutiveTotal(i))" [title]="getExecutiveTotal(i) > 0 ? formatOther(getExecutiveTotal(i)) : ''">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="executiveDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: executiveDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level comments-section">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="3"></textarea>
      </mat-form-field>
    </div>
  </section>

</div>
